import React, {useState} from "react";
import { Button, Control, Field, Select } from "@allxsmith/bestax-bulma";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";
import useEditableTableNumberCell from "../../hooks/useEditableTableNumberCell";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import MovementRatePicker from "../Movement/MovementRatePicker";
import useInlineEditButton from "../../hooks/useInlineEditButton";
import axios from "axios";
import MovementTypePicker from "../Settings/MovementType/MovementTypePicker";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import useEditableTableTimeCell from "../../hooks/useEditableTableTimeCell";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import useButtonSelect from "../../hooks/useButtonSelect";


export default function MovementRow({movement, onDelete, onChange, index, onSave, rateOptions, onRateChange, view,
                                        quoteToMovement, onComplete, movementTypes, movementTypeObjects, endpoint, disabled,
                                    selected, onSelectCheck, isJob, driverOptions, driverObjects, departments, departmentObjects}){
    const [editable, setEditable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [typeahead, setTypeahead] = useState();


    const supplierStatusOptions = [
        {name: "Internal", value: "INTERNAL"},
        {name: "External", value: "EXTERNAL"}
    ];

    const [supplierStatus, supplierStatusInput] = useButtonSelect({
        initialValue: movement.supplier_status,
        prop: "supplier_status",
        options: supplierStatusOptions,
        callback: (e) => onChange(e, index),
        disabled: !editable
    });


    const handleSupplierSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `contacts?contact_type=SP&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    }


    const getColor = () => {
        if(movement.invoice_number){
            return "table-highlight-green"
        }
        else if(movement.job){
            return "colored"
        }
        else if(movement.movement_type && (movement.movement_type.name === "ONHIRE" || movement.movement_type.name === "OFFHIRE")){
            return "table-highlight-orange"
        }
        else if(movement.rental) {return "table-highlight-orange"}
        else{
            return "table-highlight-dark-red"
        }
    }
    let color = getColor();

    const getSource = () => {
        if(movement.job){
            return "JOB"
        }
        else if(movement.rental){
            return "RENTAL"
        }
        else{
            return "USER CREATED"
        }
    }

    const onRowClick = () =>{
        if(movement.job){
            window.open("/editjob/"+movement.job.id, "_self");
        }
    }
    const overrideOptions = [
        {name:"No", value: false},
        {name:"Yes", value: true}
    ];

    const onTypeChange = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: movementTypeObjects[e.target.value]
            }
        };
        onChange(toUpdate, index);
    };

    const onDepartmentChange = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: departmentObjects[e.target.value]
            }
        };
        onChange(toUpdate, index)
    }

    const onCostOverrideChange = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: !movement.cost_override
            }
        };
        onChange(toUpdate, index);
    }

    const onDriverChange = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: driverObjects[e.target.value]
            }
        };
        onChange(toUpdate, index)
    }

    const onSupplierChange = e => {
        const toUpdate = {
            target: {
                name: "external_supplier",
                value: e[0]
            }
        }
        onChange(toUpdate, index)
    }

    const onVehicleUsedChange = e => {
        const toUpdate = {
            target: {
                name:"vehicle_used",
                value: e[0]
            }
        };
        onChange(toUpdate, index);
    };
    const onCheck = e => {
        e.stopPropagation();
        onSelectCheck(movement);
    };
    const handleVehicleSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `vehicles?showAll=true&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    const onCustomerChange = e => {
        const toUpdate = {
            target: {
                name:"customer",
                value: e[0]
            }
        };
        onChange(toUpdate, index);
    };

    const handleCustomerSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `contacts?contact_type=CC&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    let rows = []
    const firstRow = (
        <tr
            key={movement.id} className={color}
        >
            <td>
                {useEditableTableTextCell({
                    propName: "id",
                    value: movement.id,
                    disabled: true
                })}
            </td>
            <td>
                <MovementTypePicker
                    editable={editable}
                    setEditable={setEditable}
                    inlineEdit={!disabled}
                    disabled={!editable || disabled}
                    options={movementTypes ?? {results: []}}
                    onSave={() => {
                        onSave(movement);
                        setEditable(false);
                    }}
                    value={movement.movement_type}
                    onChange={onTypeChange}
                />
            </td>
            <td>
                {
                    useEditableTableTextCell({
                        propName: "creator",
                        value: movement.creator ? movement.creator.first_name + " " + movement.creator.last_name : ""
                    })
                }
            </td>
            <td>
                {useEditableTableDateCell({
                    propName: "delivery_date",
                    value: movement.delivery_date,
                    onChange: (e) => onChange(e, index),
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                <Button
                    onClick={() => onDelete(movement)}
                    disabled={movement.completed}
                    color={"danger"}
                >
                    X
                </Button>
            </td>
            {(view === "QUOTE" && movement.movement_status === "QUOTE") ?
                <td>
                    <Button
                        onClick={() => quoteToMovement(movement)}
                        color={"success"}
                    >
                        Movement
                    </Button>
                </td> :
                <td></td>
            }
        </tr>
    );
    rows.push(firstRow);
    const secondRow = (
        <tr
            className={color}
        >
            <th>Start Address</th>
            <th>End Address</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th></th>
            <th></th>
        </tr>
    )
    rows.push(secondRow);

    const thirdRow = (
        <tr
            className={color}
        >
            <td>
                {useEditableTableTextAreaCell({
                    propName: "start_address",
                    value: movement.start_address,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName: "end_address",
                    value: movement.end_address,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableTimeCell({
                    propName: "start_time",
                    value: movement.start_time,
                    onChange: (e) => onChange(e, index),
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td>
                {useEditableTableTimeCell({
                    propName: "end_time",
                    value: movement.end_time,
                    onChange: (e) => onChange(e, index),
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: disabled,
                    onSave: () => {
                        onSave(movement);
                        setEditable(false);
                    }
                })}
            </td>
            <td></td>
            <td></td>
        </tr>
    )
    rows = rows.concat(thirdRow);

    const forthRow = (
        <tr
            className={color}
        >
           <th>Customer Charger</th>
           <th>Rate</th>
           <th>Miles</th>
           <th>Customer Charge</th>
           <th colSpan={2}>Cost Override</th>
        </tr>
    )
    rows.push(forthRow);
    const fithRow = (
        <tr
            className={color}
        >
            <td>
                <DepartmentSelector
                    name={"department"}
                    inlineEdit={!disabled}
                    blank={false}
                    setEditable={setEditable}
                    editable={editable}
                    value={movement.department}
                    options={departments}
                    onSave={() => {
                            onSave(movement);
                            setEditable(false);
                    }}
                    onChange={onDepartmentChange}
                    classname={""}
                    disabled={disabled || !editable}
                />
            </td>
            <td>
                {
                    <MovementRatePicker
                        editable={editable}
                        setEditable={setEditable}
                        movement={movement}
                        options={rateOptions ?? {results: []}}
                        onChange={(e) => onRateChange(e, index)}
                        onSave={() => {
                            onSave(movement);
                            setEditable(false);
                        }}
                        inlineEdit={!disabled}
                        disabled={!editable || disabled}
                        blank={true}
                        className={"small-column"}
                    />
                }
            </td>
            <td>
                {useEditableTableNumberCell({
                    propName: "miles",
                    value: movement.miles,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(movement);
                        setEditable(false)
                    },
                    disabled: disabled,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "cost",
                    value: movement.cost,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(movement);
                        setEditable(false)
                    },
                    disabled: disabled,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td colSpan={2}>
                <Field className={"has-addons"}>
                    <Control>
                        <Select
                            onChange={onCostOverrideChange}
                            disabled={!editable || disabled}
                            value={movement.cost_override}
                            name={"cost_override"}
                        >
                            {overrideOptions.map(item => (
                                <option key={item.name} value={item.value}>
                                    {item.name}
                                </option>
                            ))}
                        </Select>
                    </Control>
                    {useInlineEditButton({
                        show: true,
                        onSave: () => {
                            onSave(movement);
                            setEditable(false)
                        },
                        setEditable,
                        editable,
                        disabled: disabled
                    })}
                </Field>
            </td>
        </tr>
    )
    rows.push(fithRow);

    const sixthRow = (
        <tr>
            <th className={color}>Supplier Status</th>
            <th className={color}>Supplier</th>
            <th className={color}>Supplier Charge</th>
            <th className={color}>Comments</th>
            <th colSpan={2} className={color}>Order Number</th>
        </tr>
    )
    rows = rows.concat(sixthRow);
    const seventhRow = (
        <tr
            className={color}
        >
            <td>
                {supplierStatusInput}
            </td>
            {movement.supplier_status === "INTERNAL" ?
            <td>
                <DepartmentSelector
                    name={"movement_performer"}
                    inlineEdit={!disabled}
                    blank={true}
                    setEditable={setEditable}
                    editable={editable}
                    value={movement.movement_performer}
                    options={departments}
                    onSave={() => {
                            onSave(movement);
                            setEditable(false);
                    }}
                    onChange={onDepartmentChange}
                    classname={""}
                    disabled={disabled || !editable}
                />
            </td> :
            <td>
                <AsyncTypeahead
                    useCache={false}
                    isLoading={loading}
                    id="typeahead"
                    labelKey="display_name"
                    minLength={2}
                    name={"external_supplier"}
                    onSearch={handleSupplierSearch}
                    onChange={onSupplierChange}
                    placeholder={`Search Supplier`}
                    options={searchData}
                    ref={typeahead => setTypeahead(typeahead)}
                    className="typeahead"
                    disabled={!editable || disabled}
                    selected={movement.external_supplier && movement.external_supplier.id ? [movement.external_supplier] : []}
                />
            </td>
            }
            <td>
                {useEditableTableCostCell({
                    propName: "internal_charge",
                    value: movement.internal_charge,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(movement);
                        setEditable(false)
                    },
                    disabled: disabled,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName: "comments",
                    value: movement.comments,
                    onChange: (e) => {
                        e.stopPropagation();
                        onChange(e, index);
                    },
                    onSave: () => {
                        onSave(movement);
                        setEditable(false)
                    },
                    disabled: disabled,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
            <td colSpan={2}>
                {useEditableTableTextCell({
                    propName: "order_number",
                    value: movement.order_number,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(movement);
                        setEditable(false)
                    },
                    disabled: disabled,
                    editable,
                    setEditable,
                    inlineEdit: true
                })}
            </td>
        </tr>
    )
    rows = rows.concat(seventhRow);
    const eithRow = (
        <tr className={"table-highlight-black"}>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
        </tr>
    );
    rows = rows.concat(eithRow);
    return rows;
}